
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CircularProgress, Dialog } from '@mui/material';
import { Calendar, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import Actions_Wind from '~/Actions_Wind';
import PageTitle from '~/components/PageTitle';

import Card from '~/containers/Page_Main/Page_InfoManagement/Page_ProjectProgress/Page_PPDaily/Card';
import Detail from '~/containers/Page_Main/Page_InfoManagement/Page_ProjectProgress/Page_PPDaily/Detail';

class Page_PPDaily extends Component {
  state={
    // currentId: '',
    // view_addAndEdit: false,
    // mode_addAndEdit: '',
    // currentDate: '',
    date: moment(),
    week: 6,
    opacity: 0,
    transition: '',
  }

  componentDidMount () {
    this.getData();
  }

  componentDidUpdate (preProps) {
    if (!preProps.PPDailyList && this.props.PPDailyList) { this.setState({ opacity: 1, transition: 'opacity 1s' }); }
  }

  getData=M => {
    const { clearList, getPPDailyList } = this.props;
    const m = M || moment();
    const m_s = moment(m).startOf('month');
    const minDate = m_s.subtract(m_s.day() + 1, 'days');
    const m_e = moment(m).endOf('month');
    const maxDate = m_e.add(6 - m_e.day(), 'days');
    this.setState({
      date: M || this.state.date,
      week: (maxDate.diff(minDate, 'day') + 1) / 7,
      opacity: 0,
      transition: '',
    });
    clearList();
    getPPDailyList({
      query_field: 'now_date',
      start_date: minDate.format('YYYY-MM-DD'),
      end_date: maxDate.format('YYYY-MM-DD'),
    }, this.props.windId);
  }

  // _add=currentDate => this.setState({ view_addAndEdit: true, mode_addAndEdit: 'add', currentDate })
  // // _view=id => this.setState({ currentId: id, view_addAndEdit: true, mode_addAndEdit: 'view' })
  // _edit=(currentId, currentDate) => this.setState({ currentId, view_addAndEdit: true, mode_addAndEdit: 'edit', currentDate });
  // _close_view_addAndEdit=(func = () => {}) => {
  //   this.getData(this.state.date);
  //   this.setState({ currentId: '', view_addAndEdit: false, mode_addAndEdit: '', currentDate: '' }, func);
  // }

  renderDay = (day, selectedDate, dayInCurrentMonth/* bool */, dayComponent/* icon button props */) => {
    const { PPDailyList = [] } = this.props;
    const currentDate = day.format('YYYY-MM-DD');
    const isToday = moment().format('YYYY-MM-DD') === currentDate;
    let data = null;
    for (const o of PPDailyList) {
      if (moment(new Date(o.now_date)).format('YYYY-MM-DD') === currentDate)data = o;
    }
    const haveData = !!data;
    const onClick = () => {
      // if (haveData) this._edit(data.id, currentDate);
      // else this._add(currentDate);
    };
    const overToday = !isToday && (day > moment());

    const props = {
      day,
      dayInCurrentMonth,
      isToday,
      onClick,
      data,
      haveData,
      overToday,
    };
    return <Card {...props} />;
  };

  render () {
    const { week, opacity, transition } = this.state;
    const h = 920 + (week - 5) * 160;
    return (
      <div
        style={{
          height: 'calc(100% - 30px)',
          // width: '80%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'start',
          overflow: 'auto',
          backgroundColor: 'white',
          borderRadius: 30,
        }}
      >
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {opacity === 0 && <CircularProgress style={{ color: '#B2D6DB' }} />}
          <div style={{ width: 757, height: h, backgroundColor: '#F9F9F9', borderRadius: 30, opacity, transition }}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <Calendar
                date={this.state.date}
                renderDay={this.renderDay}
                onMonthChange={this.getData}
                onChange={(date, isFinish) => {}}
                maxDate={moment()}
              />
            </MuiPickersUtilsProvider>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  PPDailyList: (state.data.PPDailyList || {}).list,
});
const mapDispatchToProps = dispatch => ({
  clearList: () => Actions_Wind.clearKey(dispatch, { key: 'PPDailyList' }),
  getPPDailyList: (body, windId) => Actions_Wind.getPPDailyList(dispatch, { body, windId }),
});

const PaperComponent = connect(mapStateToProps, mapDispatchToProps)(Page_PPDaily);

const DailyDialog = props => {
  const { windId, displayDaily, setDisplayDaily } = props;
  return (
    <Dialog
      open={displayDaily}
      PaperComponent={PaperComponent}
      PaperProps={{ windId }}
      onClose={() => setDisplayDaily(false)}
    />
  );
};

export default DailyDialog;
